import { globalStore } from 'tradera-state/configure-store';
const store = globalStore();

export default {
    setErrors: function(errors) {
        store.dispatch({
            type: 'SET_ERRORS',
            errors: errors
        });
    },
    setError: function(propertyName, error) {
        store.dispatch({
            type: 'SET_ERROR',
            propertyName: propertyName,
            error: error
        });
    }
};
